import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, BackTop, Button, Breadcrumb, Alert, Typography } from 'antd';
import { DoubleRightOutlined, PlusOutlined } from '@ant-design/icons';
import { TableList } from 'components/list';
import ModalForm from '../modal/Form';
import Filter from '../modal/Filter';
import ModalDelete from '../modal/Delete';
import SearchTable from 'components/search-table/SearchTable';
import { PageHeader } from 'components/header';
import { SortingTableWithFilter } from 'components/sorting-table';
import columns from './Columns';
import useList from '../hooks/useList';
import { isAuth } from 'lib/Helper';
import AuthRedirect from 'components/AuthRedirect';
import Dashboard from './Dashboard';
const { Title } = Typography;

const sortFields = [{
  value: "id",
  label: "Tanggal Pembuatan",
}];

const PenilaianKkmKttp = ({ privilege }) => {
  const {
    action,
    table,
    formState,
    filterState,
    deleteState,
    fetchTable,
    fetchData,
    setTempTableFilter,
    setTableFilterFromTemp,
    statisticState,
    modalFilter,
    modalForm,
    modalDelete,
  } = useList(privilege);

  if (!isAuth(privilege) || (action === undefined)) {
    return <AuthRedirect />
  }

  return (
    <>
      <PageHeader
        style={{
          padding: 0
        }}
        onBack={() => window.history.back()}
        title={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
          <Breadcrumb.Item>Penilaian</Breadcrumb.Item>
          <Breadcrumb.Item>KKM/KTTP </Breadcrumb.Item>
        </Breadcrumb>}
      />
      <Alert message={<>
        <Title style={{ marginTop: 0 }} level={5}>Petunjuk Pengisian KKM/KTTP</Title>
        <ul>
          <li>Silakan isi KKM untuk masing-masing tingkatan.</li>
          <li>Jika menggunakan KKM Tunggal, isi KKM di setiap tingkatan dengan nilai yang sama.</li>
          <li>Untuk tingkatan yang menggunakan Kurikulum Merdeka, isi dengan nilai KTTP.</li>
          <li>Nilai KKM/KTTP tidak dapat diedit apabila nilai mata pelajaran telah terkirim.</li>
        </ul>
        {/* Silahkan isi KKM masing-masing tingkatan. Jika menggunakan KKM Tunggal, isi KKM tiap tingkatan dengan nilai yang sama. Untuk tingkatan yang menggunakan kurikulum Merdeka, silahkan isi dengan menggunakan nilai KTTP. Nilai KKM/KTTP tidak bisa diedit apabila nilai mapel terlah terkirim. */}
      </>} type="info" />

      <Dashboard statisticState={statisticState} />
      
      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>

        <PageHeader
          className="site-page-header"
          title="KKM/KTTP"
          subTitle="Data KKM/KTTP"
          extra={[
            action.create && (
              <Button
                type='primary'
                onClick={() => modalForm(true)}
                icon={<PlusOutlined />}>
                Tambah
              </Button>
            )
          ]} />

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={18} md={19}>
            <SearchTable table={table} fetch={fetchData} />
          </Col>
          <Col xs={24} sm={6} md={5}>
            <SortingTableWithFilter
              table={table}
              fetch={fetchData}
              modalFilter={modalFilter}
              sortFields={sortFields}
            />
          </Col>
          <Col xs={24}>
            <TableList
              state={{ table, filterState }}
              fetch={fetchData}
              fetchTable={fetchTable}
              columns={columns(action, modalForm, modalDelete)}
            />
          </Col>
        </Row>
      </div>
      {
        formState.visible && (
          <ModalForm
            data={formState.data}
            visible={formState.visible}
            hideModal={() => modalForm(false)}
            fetchTable={fetchTable}
          />
        )
      }
      {
        filterState.visible && (
          <Filter
            visible={filterState.visible}
            hideModal={() => modalFilter(false)}
            setTempTableFilter={setTempTableFilter}
            setTableFilterFromTemp={setTableFilterFromTemp}
            values={filterState.values}
          />
        )
      }
      {
        deleteState.visible && (
          <ModalDelete
            data={deleteState.data}
            visible={deleteState.visible}
            hideModal={() => modalDelete(false)}
            fetchTable={fetchTable}
          />
        )
      }
      <BackTop />
    </>
  );
};

const mapStateToProps = (state) => ({
  privilege: state.privilege,
});

export default connect(mapStateToProps)(PenilaianKkmKttp);